import React from 'react'
import PropTypes from 'prop-types'
import TopPanelMenu from 'components/TopPanelMenu'

export default class extends React.Component {
  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {
      permissions
    } = this.context

    // const canViewLaningPages = permissions.show.includes('@features/landingPages')
    // if (!canViewLaningPages) return null

    return (
      <TopPanelMenu
        items={[
          {to: '/conversion/funnels', limitKey: 'pageInsight', limitType: 'show', title: 'Funnels'},
          {to: '/conversion/landings', limitKey: 'landingPages', limitType: 'show', title: 'Landing pages'}
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/LandingsInsightView/menu.js